import Vue from 'vue'
import Vuex from 'vuex'
import dailog from './modules/dailog'
import dynamicRouter from './modules/dynamicRouters'
import cacheTabs from './modules/cacheTabs'
import pageHeight from './modules/pageHeight'
import queryAll from './modules/queryAll'
import AppInfo from './modules/AppInfo'
import Report from './modules/Report'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    dailog,
    dynamicRouter,
    cacheTabs,
    pageHeight,
    queryAll,
    AppInfo,
    Report
  }

})
